import React, { useState, useEffect } from "react"
import Icon from "../../../components/AppIcon"
import { Card } from "../../../components/ui/card"
import { getProgramCohorts } from "../../../utils/programDetailHelpers"

const ProgramCohortsTab = ({ orgId, courseIds }) => {
  const [cohorts, setCohorts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    getProgramCohorts(orgId, courseIds || []).then((list) => {
      setCohorts(list || [])
      setLoading(false)
    })
  }, [orgId, courseIds])

  if (loading) return <div className="p-8 text-center text-sm text-muted-foreground">Loading cohorts...</div>

  if (cohorts?.length === 0) {
    return (
      <Card className="p-12 text-center dark:bg-transparent">
        <Icon name="UsersRound" size={24} className="text-muted-foreground mx-auto mb-3" />
        <p className="text-sm text-muted-foreground">No cohorts assigned across this program's courses yet.</p>
        <p className="text-xs text-muted-foreground mt-1">Assign learners to cohorts from the Cohorts section on individual courses.</p>
      </Card>
    )
  }

  return (
    <Card className="p-0 dark:bg-transparent overflow-hidden">
      <div className="divide-y divide-border">
        {cohorts?.map((cohort) => (
          <div key={cohort?.name} className="flex items-center justify-between px-4 py-3">
            <span className="text-sm font-medium text-foreground">{cohort?.name}</span>
            <div className="flex items-center gap-6 text-xs text-muted-foreground">
              <span>{cohort?.learners} learners</span>
              <span>{cohort?.avgProgress}% avg. progress</span>
            </div>
          </div>
        ))}
      </div>
    </Card>
  )
}

export default ProgramCohortsTab